module.exports = __webpack_public_path__ + "img/changeAllocation-2@2x.e54ab7e.webp";